function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "AEFFFD90-F879-40ED-8CC5-F22401AC51C9");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Admissions",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "anuAdmissionsGeneralInformation",
  transform: "translate(-1272.000000, -415.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "sideBar",
  transform: "translate(1237.000000, 351.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "sidebarSection1Expanded",
  transform: "translate(0.000000, 50.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "groupSidebarHeader"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.5,27 C45.0907258,27 48,24.0907258 48,20.5 C48,16.9092742 45.0907258,14 41.5,14 C37.9092742,14 35,16.9092742 35,20.5 C35,24.0907258 37.9092742,27 41.5,27 Z M44.9596774,21.5483871 L38.0403226,21.5483871 C37.8673489,21.5483871 37.7258065,21.4068446 37.7258065,21.233871 L37.7258065,19.766129 C37.7258065,19.5931554 37.8673489,19.4516129 38.0403226,19.4516129 L44.9596774,19.4516129 C45.1326511,19.4516129 45.2741935,19.5931554 45.2741935,19.766129 L45.2741935,21.233871 C45.2741935,21.4068446 45.1326511,21.5483871 44.9596774,21.5483871 Z",
  id: "iconStatusMinusCircle"
}))))));

var SvgDecktopMinusCircle = function SvgDecktopMinusCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDecktopMinusCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/decktop-minus-circle.e2490329.svg";
export { ForwardRef as ReactComponent };